import yqzResource from '~/resource'

export function resizeImage({ src, width, height, defaultImg, scale }) {
  if (!width && !height) return src
  const screenWidth = Number(document.documentElement.clientWidth)

  const SCALE = scale || process.env.IMG_SCALE || 1.5
  let format = ''
  if (width) {
    width = /\d+%/.test(width.toString())
      ? (width.toString().replace('%', '') / 100) * screenWidth
      : width
    format += 'w' + width * SCALE
  }
  if (height) {
    format += 'h' + height * SCALE
  }
  const returnRes = formatOssUrl(src, format, defaultImg)
  return returnRes
}

function formatOssUrl(ossImage, format, imgType) {
  let ossUrl
  if (ossImage) {
    if (isOssImageUrl(ossImage)) {
      // 如果已经包含了后缀,则去后缀: ?及以后的东西
      ossUrl = ossImage.replace(/\?.*$/, '')
    } else {
      return ossImage
    }
    ossUrl += generateOssImageProcess(format)
    return ossUrl
  }
  // // image为空,则用默认图片
  if (imgType) return yqzResource.defaultImg[imgType]
  return ''
}

function isOssImageUrl(url) {
  // oss-cn-qingdao.aliyuncs.com oss.1qizhuang.com media.1qizhuang.com
  return (
    /^http.*oss.*aliyun.*$/.test(url) ||
    /^http.*media.*1qizhuang.*$/.test(url) ||
    /^http.*oss.*1qizhuang.*$/.test(url)
  )
}

function generateOssImageProcess(_format) {
  // image/resize,m_fill,w_800,h_600,limit_0/auto-orient,1/quality,q_90

  let width
  let height
  // 提取高度和宽度
  if (_format) {
    width = _format.replace(/^.*w(\d+)(?!\d).*$/, '$1')
    height = _format.replace(/^.*h(\d+)(?!\d).*$/, '$1')
  } else {
    width = 750
  }

  let ossProcess = '?x-oss-process=image/resize,m_fill'
  // 如果包含宽度
  if (/^\d+$/.test(width)) {
    ossProcess = ossProcess + ',w_' + width
  }
  // 如果包含高度
  if (/^\d+$/.test(height)) {
    ossProcess = ossProcess + ',h_' + height
  }

  // 如果只有高度和宽度中的1个
  if (!/^\d+$/.test(width) || !/^\d+$/.test(height)) {
    ossProcess = ossProcess.replace('m_fill', 'm_lfit')
  }

  ossProcess += ',limit_0/auto-orient,1/quality,q_90'
  // console.log('ossProcess url',ossProcess);
  return ossProcess
}
